import {
  Component,
  HostBinding,
  Injector,
  Optional
} from '@angular/core';
import {
  DISPLAY_TYPE,
  IWidgetConfig,
  StylableComponent, provideAsWidgetRef, Parent, styler,
  WmComponentsModule, register
} from "@wm/components-base";
import {CommonModule} from "@angular/common";

const DEFAULT_CLS = 'btn app-button';
const WIDGET_CONFIG: IWidgetConfig = {
  widgetType: 'wm-button',
  hostClass: DEFAULT_CLS,
  displayType: DISPLAY_TYPE.INLINE_BLOCK
};

@Component({
  selector: 'button[wmButton]',
  template: `<img data-identifier="img" alt="button image" class="button-image-icon" [src]="iconurl | image" *ngIf="iconurl" [ngStyle]="{width:iconwidth, height:iconheight, margin:iconmargin}"/>
  <i class="app-icon {{iconclass}}" aria-hidden="true" [ngStyle]="{width:iconwidth, height:iconheight, margin:iconmargin, fontSize:iconwidth}" *ngIf="iconclass"></i>
  <span class="sr-only" *ngIf="iconclass">{{caption}}</span>
  <span class="btn-caption" [innerHTML]="caption"></span>
  <ng-content select=".caret"></ng-content>
  <span *ngIf="badgevalue" class="badge pull-right" [textContent]="badgevalue"></span>`,
  providers: [
    provideAsWidgetRef(ButtonComponent)
  ],
  exportAs: 'wmButton',
  standalone: true,
  imports: [ CommonModule, WmComponentsModule ]
})
export class ButtonComponent extends StylableComponent {
  static initializeProps = register('wm-button');

  public iconwidth: any;
  public iconheight: any;
  public iconmargin: any;

  public iconurl: string = '';
  public iconclass: string = '';
  public caption: string = '';
  public badgevalue: string = '';
  @HostBinding('type') type: string = '';
  @HostBinding('tabIndex') tabindex: number = 0;
  @HostBinding('attr.accesskey') shortcutkey: string = '';
  @HostBinding('attr.icon-position') iconposition: string = '';


  constructor(inj: Injector,
              @Optional() viewParent: Parent) {
    super(inj, WIDGET_CONFIG, viewParent);
    styler(this.nativeElement, this);
  }

}
